import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, Heading, ResponsiveContext } from "grommet";
import * as React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import SkeletonWrapper from "../components/SkeletonWrapper";
import StatDetails from "./StatDetails";
import { StatIcon } from "./StatIcon";
import { getStat, StatViewModel, updateStat, UpdateStatRequest } from "./StatsStore";

const plus = <FontAwesomeIcon icon={["fad", "plus"]}></FontAwesomeIcon>;
const edit = <FontAwesomeIcon icon={["fad", "pencil"]}></FontAwesomeIcon>;
const idBadge = <FontAwesomeIcon icon={["fad", "id-badge"]}></FontAwesomeIcon>;
const chain = <FontAwesomeIcon icon={["fad", "chain"]}></FontAwesomeIcon>;
const xmark = <FontAwesomeIcon icon={["fad", "xmark"]}></FontAwesomeIcon>;

const StatProfile = () => {
    let { statID } = useParams<{ statID: string }>();

    let { pathname } = useLocation();
    let navigate = useNavigate();

    const [stat, setStat] = React.useState(new StatViewModel());
    const [isLoading, setIsLoading] = React.useState(true);

    React.useEffect(() => {
        if (stat.id) {
            if (pathname == `/stats/${statID}`) {
                navigate(`/stats/${statID}/seasons`, { replace: true });
            }
        }
    }, [pathname, stat.id]);

    let [error, setError] = React.useState("");

    React.useEffect(() => {
        loadStat();
    }, []);

    const size = React.useContext(ResponsiveContext);

    const loadStat = () => {
        setIsLoading(true);
        getStat(statID).then((res) => {
            setStat(res.result);
            setIsLoading(false);
        });
    };

    // const [upcomingMatches, setUpcomingMatches] = React.useState([] as StatMatchViewModel[]);
    // const [pastMatches, setPastMatches] = React.useState([] as StatMatchViewModel[]);

    const [isUpdating, setIsUpdating] = React.useState(false);

    const onChange = (updatedStat) => {
        setStat({ ...stat, ...updatedStat });
    };

    let update = () => {
        setIsUpdating(true);
        updateStat(stat as UpdateStatRequest).then(
            (result) => {
                getStat(statID).then((res) => setStat(res.result));
                setIsUpdating(false);
            },
            (error) => {
                setError(error);
                setIsUpdating(false);
            }
        );
    };

    return (
        <Box>
            <SkeletonWrapper loading={isLoading}>
                <Heading size="small">
                    {StatIcon(stat)} {stat.name}
                </Heading>

                <StatDetails stat={stat} isBusy={isUpdating} onChange={onChange}></StatDetails>
                <br />
                <Button primary onClick={update} disabled={isUpdating} label="Update"></Button>
            </SkeletonWrapper>
        </Box>
    );
};

export default StatProfile;
